module.exports = __webpack_public_path__ + "static/media/icons.8e3c7f55.eot";